import type { FC } from 'react';
import { forwardRef } from 'react';
import { DesktopDatePicker, LocalizationProvider } from '@material-ui/lab';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import { TextField } from '@material-ui/core';
import esLocale from 'date-fns/locale/es';

interface DatePickerProps {
  onChange: (...any) => void;
  label: string;
  name: string;
  value: Date;
}

const DatePicker: FC<DatePickerProps> = forwardRef((props, ref) => {
  const { value, label, onChange, name } = props;

  const changeDatePicker = (valueChange) => {
    onChange(name, valueChange);
  };

  return (
    <LocalizationProvider
      locale={esLocale}
      dateAdapter={AdapterDateFns}
      ref={ref}
    >
      <DesktopDatePicker
        disableCloseOnSelect={false}
        label={label}
        inputFormat="dd/MM/yyyy"
        showToolbar={false}
        renderInput={(propsInput) => (
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            {...propsInput}
          />
        )}
        onChange={changeDatePicker}
        value={value}
      />
    </LocalizationProvider>
  );
});

export default DatePicker;
